import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';
import {interfaceStore} from '@store/settings/interface/interface.store';

export const getInterfaceEntitiesDataSource = createRequestDataSource({
  store: interfaceStore,
  data$: () => interfaceStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getInterfaceEntities',
  dataKey: 'interfaceEntities',
});
